export const modalAlertTemplate = (args) => {
    return `<div class="modal modal-alert ${args.classes}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="gral-loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                        <p>${args.body}</p>
                    </div>
                </div>
            </div>
        </div>`;
};
